import { render, staticRenderFns } from "./PersonnelInfo.vue?vue&type=template&id=54a20538&scoped=true"
import script from "./PersonnelInfo.vue?vue&type=script&lang=js"
export * from "./PersonnelInfo.vue?vue&type=script&lang=js"
import style0 from "./PersonnelInfo.vue?vue&type=style&index=0&id=54a20538&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a20538",
  null
  
)

export default component.exports